/**
 * This mixin is used to prevent 2 clicks in a row.
 */

export default {
  data: () => ({
    locked: false,
  }),

  methods: {
    lock (timeout = 75) {
      this.locked = true
      setTimeout(() => this.locked = false, timeout)
    },
    /**
     * Try to acquire lock. Returns true if lock was acquired, false if already locked.
     * This prevents race conditions when checking and setting the lock.
     */
    tryLock (timeout = 75) {
      if (this.locked) {
        return false
      }
      this.locked = true
      setTimeout(() => this.locked = false, timeout)
      return true
    },
  },
}
